import classNames from "classnames";
import { Color } from "utils/theme";

interface Props {
  progress: number;
  size?: "small" | "large";
  color?: string;
  className?: string;
}

export const ProgressBar = ({
  progress = 0,
  color,
  size = "small",
  className = "",
}: Props) => {
  return (
    <div
      className={classNames("w-full relative rounded-full", {
        className,
        "h-3": size === "small",
        "h-4 lg:h-5": size === "large",
      })}
      style={{ background: Color.Primary[600] }}
    >
      <div style={{ width: `${progress}%` }}>
        <div
          className={classNames("rounded-full w-full", {
            "h-3": size === "small",
            "h-4 lg:h-5": size === "large",
          })}
          style={{ background: color ?? Color.Indigo[400] }}
        />
      </div>
    </div>
  );
};
